import React, { useEffect, useState, useRef } from 'react'
import { connect } from 'react-redux'
import { isMobile } from 'react-device-detect'
import moment from 'moment'
import PdfViewer from '../../../../module/pdf/PdfViewer'
import { alertActions, contracterActions, certboxActions, modalActions } from '../../../../store/actions'
import {uriConstants} from "../../../../store/constants";
import queryString from "query-string";
import '../../../../assets/css/spin.css';

const CertboxList = (props) => {
  const [checkedbox, setCheckedbox] = useState(new Set())
  const checkedboxRef = useRef(checkedbox)

  const [canSubmit, setCanSubmit] = useState(false) //제출버튼 표시 여부
  const [canAccept, setCanAccept] = useState(false) //수취 버튼 표시 여부
  const [canReject, setCanReject] = useState(false) //반려 버튼 표시 여부
  const [canDelete, setCanDelete] = useState(false) //삭제 버튼 표시 여부
  const [isShowPdf, setIsShowPdf] = useState(false) //pdf버튼 버튼 표시 여부
  const [canDownload, setCanDownload] = useState(false)      // 다운로드 버튼 표시 여부

  const [active, setActive] = useState()

  const [showEdit, setShowEdit] = useState() //퍼블리싱임시: 체크선택시 옵션기능보여줌 06.23

  const [contAllCheck, setContAllCheck] = useState(false)
  const [showResponse, setShowResponse] = useState()
  const [showFileNm, setShowFileNm] = useState()
  const [blobResponse, setBlobResponse] = useState()
  const [docid, setDocid] = useState()
  const [crtCd, setCrtCd] = useState()
  const [brno, setBrno] = useState()
  const [oldYn, setOldYn] = useState()
  const [fileId, setFileId] = useState()
  const [printYn, setPrintYn] = useState()
  const tabIdRef = useRef()

  // PDF 버튼 클릭 시 로딩 이미지 출력
  const [isLoading, setIsLoading] = useState(false)
  const xhrRef = useRef(null)


  useEffect(() => {
    if (props.tabId !== tabIdRef.current) {
      tabIdRef.current = props.tabId
      setCheckedbox(new Set())
      checkedboxRef.current.clear()
      setContAllCheck(false)
      setShowEdit(false)
    }
  }, [props.tabId])

  useEffect(() => {
    if (props.isSubmit) {
      handleAllCheck(false)
    }
  }, [props.isSubmit])

  useEffect(() => {
    let type = ''
    if (props.isDelete || props.isDelete2) {
      // 수신함 삭제 성공
      type = '삭제'
    } else if (props.isReject) {
      // 수신함 반려신청 성공
      type = '반려'
    } else if (props.isReceive) {
      // 수취완료 성공
      // type = "수취완료";
      type = '읽음'
    } else {
      return // 에러처리 전까진 그냥 리턴시킴
    }

    props.success({
      title: type + '성공',
      message: type + '되었습니다.',
      params: {
        type: 'success',
        callback: () => {
          window.location.reload()
        },
      },
    })
  }, [props.isDelete, props.isDelete2, props.isReject, props.isReceive])

  useEffect(() => {
    const fileList = props.CertboxInfo?.fileList
    const fileNewList = props.CertboxInfo?.fileNewList

    if (!fileList || !fileNewList) {
      //props.error({message: 'PDF 파일이 존재하지 않습니다.'});
      return
    }

  }, [props.CertboxInfo])

  const makeStatusBtn = (status) => {
    switch (status) {
      case '03':
        return <span className="text-blue">발급완료</span>
        break
      case '01':
        return <span className="text-gray">임시저장</span>
        break
      case '02':
        return <span className="text-black">전송완료</span>
        break
      case '04':
        return <span className="text-black">오류통보</span>
        break
      case '10':
        return <span className="text-red">안 읽음</span>
        break
      case '11':
        return <span className="text-red">반려</span>
        break
      case '12':
        return <span className="text-green">읽음</span>
        break
      default:
        return <span className="text-black">상태미정{status}</span>
    }
  }

  const onUploadDoc = () => {
    //console.log('checkedboxRef.current.size = ', checkedboxRef.current.size);
    if (checkedboxRef.current.size === 1) {
      let certbox
      for (let obj of checkedboxRef.current) {
        certbox = obj.crtCd
      }

      //console.log('certbox = ', certbox);
      if (certbox !== '02') {
        props.error({ message: '간접수출 실적 증명서만 가능합니다.' })
        return
      } else {
        props.onUploadDoc(Array.from(checkedboxRef.current))
      }
    } else {
      props.error({ message: '업로드는 목록에서 1개만 선택해주세요.' })
      return
    }
  }

  const onCertboxSubmit = () => {
    let valid = false
    checkedboxRef.current.forEach((item) => {
      if (!item.fileGroupId) {
        return (valid = true)
      }
    })

    if (valid) {
      return props.error({ message: '제출할 파일이 있는 경우에만 제출이 가능합니다.' })
    }

    props.onCertboxSubmit(Array.from(checkedboxRef.current), Array.from(props.orgdata))
  }

  const getChecked = () => {
    let checkedCrtSeqSet = new Set()
    let checkedRcvCrtSeqSet = new Set()
    for (let obj of checkedboxRef.current) {
      checkedCrtSeqSet.add(obj.crtSeq)
      checkedRcvCrtSeqSet.add(obj.crtRcvSeq)
    }
    let checkedCrtSeqArr = Array.from(checkedCrtSeqSet)
    let checkedRcvCrtSeqArr = Array.from(checkedRcvCrtSeqSet)
    return {
      checkedCrtSeq: checkedCrtSeqArr,
      checkedRcvCrtSeq: checkedRcvCrtSeqArr,
    }
  }

  const onDelete = () => {
    // 1. 유효성 체크: 삭제가 가능한건 임시저장(01), 오류통보(04), 발급완료(03), 수취완료(읽음)(12)의 경우에만
    /* 권오준 부장 삭제 2022-07-29
    for (let obj of checkedboxRef.current) {
      if (obj.crtCd === '01') {
        return props.error({
          message: '구매확인서는 삭제할 수 없습니다.',
        })
      }
    }
    */

    let checked = getChecked()
    props.confirm({
      title: '확인',
      message: '증명서를 삭제하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          const params = {
            crtSeqList: checked.checkedCrtSeq,
            crtRcvSeqList: checked.checkedRcvCrtSeq,
            type: 'receive',
          }
          props.deletecertbox(params)
        },
      },
    })
    //FIXME 일단 오류 안 나게 하나만 끌어내서 하는 걸로 바꿔 놓음. 수정해야 함.
    /*
    console.log('checkedboxRef = ', checkedboxRef.current);
    let certbox = checkedboxRef.current.pop()

    if (certbox.sts === '01' || certbox.sts === '04') {
      // 임시저장과 오류통보 삭제시
      props.confirm({
        title: '확인',
        message: '증명서를 삭제하시겠습니까?',
        params: {
          type: 'confirm',
          callback: () => {
            props.deleteTempDoc(certbox.crtSeq)
          },
        },
      })
    } else {
      let checked = getChecked()
      props.confirm({
        title: '확인',
        message: '증명서를 삭제하시겠습니까?',
        params: {
          type: 'confirm',
          callback: () => {
            const params = {
              crtSeqList: checked.checkedCrtSeq,
              crtRcvSeqList: checked.checkedRcvCrtSeq,
              type: 'receive',
            }
            props.deletecertbox(params)
          },
        },
      })
    }
    */
  }

  const onReject = () => {
    // 증명서 반려
    let checked = getChecked()
    props.confirm({
      title: '확인',
      message: '증명서를 반려하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          const params = {
            crtSeqList: checked.checkedCrtSeq,
          }
          props.rejectcertbox(params)
        },
      },
    })
  }

  const onReceive = () => {
    let checked = getChecked()
    props.confirm({
      title: '확인',
      // message: '증명서를 수취완료하시겠습니까?',
      message: '증명서를 읽은 상태로 변경하시겠습니까?',
      params: {
        type: 'confirm',
        callback: () => {
          const params = {
            crtSeqList: checked.checkedCrtSeq,
          }
          props.receivecertbox(params)
        },
      },
    })
  }

  const onDownload = () => {
    let checked = getChecked()
    let param = {
      crtSeq: checked.checkedCrtSeq
    }
     props.downloadCheckedDocs(param)
  }

  // 조건 단건 변경시
  const onSelected = (e, type, value) => {
    let changedObj = {
      type: type,
      value: value,
    }
    props.changeSearchInfo(changedObj)
  }

  /**
   * pdf download
   * //TODO someday 상위 컴퍼넌트로 끌어올릴 것
   */
  let onPdfDownOld = (crtCd, docid, brno, fileObj) => {
    let fileList = []
    if (fileObj) {
      fileList.push(fileObj)
    }
    if (!fileList || !fileList.length) {
      props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
      return
    }

    fileList.forEach((val, idx, arr) => {
      setTimeout(() => {
        if (idx === 1) {
          let url = process.env.REACT_APP_API_URL + '/portal/file/general/' + fileList[idx].encryptedId
          let xhr = new XMLHttpRequest()
          xhr.responseType = 'blob'
          xhr.onload = function () {
            setShowResponse(window.URL.createObjectURL(xhr.response))
            setBlobResponse(xhr.response)
            setShowFileNm(val['originFileNm'])
            setDocid(docid)
            setCrtCd(crtCd)
            setBrno(brno)
            setOldYn('Y')
            setFileId(fileList[idx].fileId)
            setPrintYn('N')
            setIsShowPdf(true)
          }
          xhr.open('GET', url)
          xhr.send()
        }
      }, 20)
    })
  }

  /**
   * pdf download
   * //TODO someday 상위 컴퍼넌트로 끌어올릴 것
   */
  let onPdfDown = (crtCd, docid, brno, fileObj) => {
    let fileList = []
    if (fileObj) {
      fileList.push(fileObj)
    }
    if (!fileList || !fileList.length) {
      props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
      return
    }

    setIsLoading(true)

    fileList.forEach((val, idx, arr) => {
      if (crtCd === '03' && fileList[idx].readYn === 'N') {
        const params = {
          docId: docid,
          fileId: fileList[idx].fileId,
          brno: brno,
        }
        props.getDownLoad(params)
      }

      setTimeout(() => {
        let url = process.env.REACT_APP_API_URL + '/portal/file/edms/' + fileList[idx].contentId
        console.log(url)
        let xhr = new XMLHttpRequest()
        xhrRef.current = xhr

        xhr.responseType = 'blob'
        xhr.open('GET', url)
        xhr.onload = function () {
          setIsLoading(false)
          xhrRef.current = null
          if (xhr.status === 200) {
            // HTTP가 잘 동작되었다는 뜻.
            console.log(window.URL.createObjectURL(xhr.response))
            setShowResponse(window.URL.createObjectURL(xhr.response))
            setBlobResponse(xhr.response)
            setShowFileNm(val['originFileNm'])
            setDocid(docid)
            setCrtCd(crtCd)
            setBrno(brno)
            setOldYn('N')
            setFileId(fileList[idx].fileId)
            setPrintYn(fileList[idx].printYn)
            setIsShowPdf(true)
          } else {
            props.error({ message: 'PDF 파일이 존재하지 않습니다.' })
            return
          }
        }
        // 에러 처리 추가
        xhr.onerror = function () {
          setIsLoading(false) // 또는 props.setLoading(false)
          xhrRef.current = null
          props.error({ message: 'PDF 파일 다운로드에 실패했습니다.' })
        }
        xhr.send()

      }, 3000)
    })
  }
  const handleCancel = () => {
    if (xhrRef.current) {
      xhrRef.current.abort()   // ✅ 실제 요청 중단
      setIsLoading(false)
      console.log('요청취소')
    }
  }

  /**
   * @param {String} stsCd
   * @returns 선택된 계약 중에 해당 sts 인 것이 존재하는지 여부
   */
  let hasChecked = (stsCd) => {
    for (let obj of checkedboxRef.current) {
      if (obj.sts === stsCd) {
        return true
      }
      return false
    }
  }

  /**
   * @param {Array} stsCdArr
   * @returns 일치하는 거 하나라도 선택되었으면 true
   */
  // let hasAnyChecked = (stsCdArr) => {
  //   for (let obj of checkedboxRef.current) {
  //     if (stsCdArr.includes(obj.sts)) {
  //       return true
  //     }
  //   }
  //   return false
  // }

  /**
   * @param {Array} stsCdArr
   * @returns 일치하는 거 하나라도 선택되었으면 false
   */
  let hasNoneChecked = (stsCdArr) => {
    for (let obj of checkedboxRef.current) {
      if (stsCdArr.includes(obj.sts)) {
        return false
      }
    }
    return true
  }

  const stsLiteral = {
    임시저장: '01',
    전송완료: '02',
    발급완료: '03',
    오류통보: '04',

    제출: '10',
    반려: '11',
    수취완료: '12',
    회수: '13',

  }

  //복수 제어 함수
  const changeShowForm = () => {
    setShowEdit(checkedboxRef.current.size)
    const sts = stsLiteral

    //제출버튼 표시할 지 여부
    let bShowSubmit = false
    let bShowSubmit0 = false
    let bShowSubmit1 = false
    let bShowSubmit2 = false

    // 다음 건들이 선택되었을 경우 표시 안 함
    // 임시저장, 전송완료는 발급완료 전단계로 생각됨.
    // 제출, 수취완료 건은 중복 제출을 막음.
    // 오류통보, 반려, 회수 건은 수정해서 다시 제출하는 게 맞을 거라 생각됨
    //bShowSubmit = bShowSubmit && hasNoneChecked([sts.임시저장, sts.전송완료, sts.제출, sts.수취완료])

    // 수정요청(읽음, 안읽음 상태에서도 제출 가능하게)
    bShowSubmit0 = hasChecked(sts.발급완료) //발급완료 상태가 포함
    bShowSubmit1 = hasChecked(sts.제출)     //제출 상태가 포함
    bShowSubmit2 = hasChecked(sts.수취완료) //수취완료 상태가 포함
    //bShowSubmit = bShowSubmit && hasNoneChecked([sts.임시저장, sts.전송완료, sts.제출, sts.수취완료])
    bShowSubmit = (bShowSubmit0 || bShowSubmit1 || bShowSubmit2) && hasNoneChecked([sts.임시저장, sts.전송완료])
    setCanSubmit(bShowSubmit)

    //수취 버튼 표시할지 여부
    let bShowAccept = false
    bShowAccept = hasChecked(sts.제출)
    setCanAccept(bShowAccept)

    //반려 버튼 표시할지 여부
    let bShowReject = false
    bShowReject = hasChecked(sts.수취완료)
    setCanReject(bShowReject)

    //삭제 버튼 표시할지 여부
    let bShowDelete = true
    bShowDelete = checkedboxRef.current.size
    setCanDelete(bShowDelete)

    let bShowDownload = false
    bShowDownload = checkedboxRef.current.size
    setCanDownload(bShowDownload)
  }

  const handleAllCheck = (target, checked) => {
    setContAllCheck(checked)
    if (checked) {
      props.data.forEach((item) => checkedboxRef.current.add(item))
    } else {
      checkedboxRef.current.clear()
    }
    setCheckedbox(checkedboxRef.current)
    changeShowForm()
  }

  const checkedItemHandler = (id, isChecked, crtSeq, sts, crtRcvSeq, obj) => {
    if (isChecked) {
      checkedboxRef.current.add(obj)
    } else {
      for (let cont of checkedboxRef.current) {
        if (obj === cont) {
          checkedboxRef.current.delete(cont)
        }
      }
    }
    setCheckedbox(checkedboxRef.current)
    changeShowForm()
  }

  const checkHandler = ({ target }, certbox) => {
    checkedItemHandler(target.id, target.checked, certbox.crtSeq, certbox.sts, certbox.crtRcvSeq, certbox)
  }

  let indexPlus

  // const indexCount = (index) => {
  //   indexPlus = index + 1
  //   return indexPlus
  // }

  const eventHandler = (e, crtSeq) => {
    e.preventDefault()
    setActive(crtSeq)
    document.querySelectorAll('.attach-file').forEach((a)=>{
      if(a.id == crtSeq){
        a.className = 'attach-file active'
      }else{
        a.className = 'attach-file'
      }
    })
  }

  const onShowOut = (e) => {
    e.preventDefault()
    setActive('')
  }

  return (
    <>
      <div className="list-header">
        <span className="total-num">
          현재페이지 <em>{props.pagingInfo?.currentPage}</em>/{props.pagingInfo?.totalPage} {props.pagingInfo?.totalRecords}건
        </span>
        <span className="right btn-group">
          <a href="#" className="btn-gray sm" onClick={(e) => handleAllCheck(e.target, !contAllCheck)}>
            전체선택
          </a>
          {canSubmit ? (
            <a href="#" className="btn-gray sm" onClick={() => onCertboxSubmit()}>
              제출
            </a>
          ) : (
            ''
          )}
          {canAccept ? (
            <a href="#" className="btn-gray sm" onClick={() => onReceive()}>
              수취완료
            </a>
          ) : (
            ''
          )}
          {!isMobile ? (
            <a href="#" className="btn-gray sm" onClick={() => onUploadDoc()}>
              업로드
            </a>
          ) : (
            ''
          )}
          {canDownload ? (
              <a href="#" className="btn-gray sm" onClick={() => onDownload()}>
                다운로드
              </a>
          ) : (
              ''
          )}

          <a href="#" className="btn-gray sm">
            전자문서보관
          </a>

          {canReject ? (
            <a href="#" className="btn-gray sm" onClick={() => onReject()}>
              반려
            </a>
          ) : (
            ''
          )}
          {canDelete ? (
            <a href="#" className="btn-gray sm" onClick={() => onDelete()}>
              삭제
            </a>
          ) : (
            ''
          )}
        </span>
      </div>
      <div className="tbl-wrap mobile-scroll">
        <table className="tbl-list">
          <caption>선택, 신청방법, 증명서 및 발급번호 항목으로 구성</caption>
          <colgroup>
            <col style={{ width: '5%' }} />
            <col style={{ width: '13%' }} />
            <col style={{ width: '15%' }} />
            <col style={{ width: '15%' }} />
            <col style={{ width: '13%' }} />
            <col style={{ width: '11%' }} />
            <col style={{ width: '11%' }} />
            <col style={{ width: '8%' }} />
            <col />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">선택</th>
              {/*<th scope="col">신청방법</th>*/}
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'DOCID')
                  }}
                >
                  증명서 및 발급번호
                </a>
              </th>
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'PRCHS_NM')
                  }}
                >
                  발급처
                </a>
              </th>
              <th scope="col">시료명</th>
              {/*<th scope="col">*/}
              {/*  <a*/}
              {/*    href="./"*/}
              {/*    onClick={(e) => {*/}
              {/*      e.preventDefault()*/}
              {/*      props.onSelected(e, 'srhOrder', 'SUBMISSION')*/}
              {/*    }}*/}
              {/*  >*/}
              {/*    제출처*/}
              {/*  </a>*/}
              {/*</th>*/}
              <th scope="col">시험성적서 용도</th>
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'ISSUEDT')
                  }}
                >
                  발급일시
                </a>
              </th>
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'MOD_DT')
                  }}
                >
                  최종이력
                </a>
              </th>
              <th scope="col">
                <a
                  href="./"
                  onClick={(e) => {
                    e.preventDefault()
                    props.onSelected(e, 'srhOrder', 'STS')
                  }}
                >
                  상태
                </a>
              </th>
              <th scope="col">열람</th>
            </tr>
          </thead>
          <tbody>
            {props.data?.length > 0 ? (
              props.data?.map((certboxObj, index) => (
                <tr key={index}>
                  <td>
                    <input
                      type="checkbox"
                      id={`${'row-' + certboxObj.crtSeq + index}`}
                      onChange={(e) => checkHandler(e, certboxObj)}
                      checked={checkedboxRef.current.has(certboxObj)}
                    />
                    <em></em>
                  </td>
                  {/*<td onClick={() => props.onCertboxDetail(certboxObj)} className="cursor">*/}
                  {/*  {certboxObj.docType}*/}
                  {/*</td>*/}
                  <td onClick={() => props.onCertboxDetail(certboxObj)} className="cursor">
                    {certboxObj.crtNm} <span className="txt1">{certboxObj.docid}</span>
                  </td>
                  <td onClick={() => props.onCertboxDetail(certboxObj)} className="cursor">{/*발급처 */}
                    {certboxObj.prchsNm}
                  </td>
                  <td onClick={() => props.onCertboxDetail(certboxObj)} className="cursor">{/* 시료명 */}
                    {JSON.parse(certboxObj?.gnrlInfoCn || "{}")?.splore_nm}
                  </td>
                  <td onClick={() => props.onCertboxDetail(certboxObj)} className="cursor">{/* 시험성적서 용도 */}
                    {JSON.parse(certboxObj?.gnrlInfoCn || "{}")?.test_report_prpos}
                  </td>
                  {/*<td onClick={() => props.onCertboxDetail(certboxObj)} className="cursor">/!*제출처 *!/*/}
                  {/*  {certboxObj?.crtCd === '01' || certboxObj?.crtCd === '21'*/}
                  {/*    ? '-'*/}
                  {/*    : certboxObj?.crtCd === '02' && certboxObj?.submission === '타행입금'*/}
                  {/*    ? certboxObj?.prchsNm*/}
                  {/*    : certboxObj?.submission === null ? '-' : certboxObj?.submission}*/}
                  {/*</td>*/}
                  <td onClick={() => props.onCertboxDetail(certboxObj)} className="cursor">
                    {certboxObj.issuedt === null ||
                    moment(certboxObj?.issuedt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss') === 'Invalid date'
                      ? '-'
                      : moment(certboxObj?.issuedt, 'YYYYMMDDHHmmss').format('YYYY.MM.DD HH:mm:ss')}
                  </td>
                  <td onClick={() => props.onCertboxDetail(certboxObj)} className="cursor">
                    {certboxObj.modDt === null || moment(certboxObj.modDt).format('YYYY.MM.DD HH:mm:ss') === 'Invalid date'
                      ? '-'
                      : moment(certboxObj.modDt).format('YYYY.MM.DD HH:mm:ss')}
                  </td>
                  <td onClick={() => props.onCertboxDetail(certboxObj)} className="cursor">
                    {makeStatusBtn(certboxObj?.sts)}
                  </td>
                  <td>
                    {certboxObj.fileGroupId !== null && certboxObj.fileNewList?.length !== 0 && certboxObj.fileNewList?.length === 1 && (
                      <div className="attach-wrap">
                        {certboxObj.fileNewList?.map((fileObj, index) => (
                          <a
                            key={index}
                            href="#"
                            className="attach attach-link"
                            onClick={(e) => {
                              e.preventDefault()
                              onPdfDown(certboxObj.crtCd, certboxObj.docid, certboxObj.brno, fileObj)
                              return
                            }}
                          >
                            첨부
                          </a>
                        ))}
                      </div>
                    )}
                    {certboxObj.fileGroupId !== null && certboxObj.fileNewList?.length !== 0 && certboxObj.fileNewList?.length !== 1 && (
                      <div className="attach-wrap">
                        <a
                          href="#"
                          className="attach attach-link"
                          onClick={(e) => eventHandler(e, certboxObj.crtSeq + index)}
                          aria-expanded={active === certboxObj.crtSeq + index ? 'true' : 'false'}
                          aria-controls={certboxObj.crtSeq + index}
                          aria-disabled={active === certboxObj.crtSeq + index ? 'true' : 'false'}
                        >
                          첨부
                        </a>
                        <ul
                          id={certboxObj.crtSeq + index}
                          // className={active === certboxObj.crtSeq + index ? 'attach-file active' : 'attach-file'}
                          className='attach-file'
                        >
                          {certboxObj.fileNewList?.map((fileObj, index) => (
                            <li key={index}>
                              <a
                                onClick={(e) => {
                                  e.preventDefault()
                                  onPdfDown(certboxObj.crtCd, certboxObj.docid, certboxObj.brno, fileObj)
                            	  onShowOut(e)
                                  return
                                }}
                              >
                                {fileObj.originFileNm}
                              </a>
                            </li>
                          ))}
                        </ul>
                      </div>
                    )}
                    {certboxObj.fileGroupId === null && '-'}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td className="center" colSpan={9}>
                  <div className="nodata">조회 결과가 없습니다.</div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      {isShowPdf === true && (
        <PdfViewer
          blobResponse={blobResponse}
          showResponse={showResponse}
          fileNm={showFileNm}
          crtCd={crtCd}
          docid={docid}
          brno={brno}
          oldYn={oldYn}
          fileId={fileId}
          printYn={printYn}
          onClose={() => setIsShowPdf(false)}
        />
      )}
      {isLoading === true && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            // 1. 세로 방향으로 배치 (-important!)
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 9998
          }}>
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              backgroundColor: 'rgba(0, 0, 0, 0.5)',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              zIndex: 9999,
            }}>
            </div>
            <div style={{
              width: '50px',
              height: '50px',
              border: '5px solid #f3f3f3',
              borderTop: '5px solid #3498db',
              borderRadius: '50%',
              animation: 'spin 1s linear infinite'
            }} />
            {/* 2. 추가할 코멘트 텍스트 */}
            <p style={{
              marginTop: '20px', // 스피너와의 간격
              marginBottom: '20px',
              color: '#ffffff',  // 어두운 배경이므로 흰색 글씨
              fontSize: '16px',
              fontWeight: '500',
              textAlign: 'center'
            }}>
              파일을 조회하고 있습니다. <br />
              잠시만 기다려주세요.
            </p>
            {/*<button style={{zIndex: 9999}} onClick={handleCancel} className="btn-gray sm"> 취소 </button>*/}

          </div>
      )}
    </>
  )
}

const mapStateToProps = (state) => {
  return {
    certboxInfo: state.certbox?.certboxInfo,
    isDelete: state.certbox?.isDelete,
    isDelete2: state.contracter?.isDelete,
    isReject: state.certbox?.isReject,
    isSubmit: state.certbox?.isSubmit,
    isReceive: state.certbox?.isReceive,
    isLoading: state.certbox?.isLoading,
    isCheckedDownloading: state.isCheckedDownloading,
  }
}

const actionCreators = {
  getcertboxInfo: certboxActions.getcertboxInfo,
  changeSearchInfo: certboxActions.changeSearchInfo,
  deletecertbox: certboxActions.deletecertboxList,
  rejectcertbox: certboxActions.rejectcertbox,
  readcertboxList: certboxActions.readcertboxList,
  receivecertbox: certboxActions.receivecertbox,
  deleteTempDoc: contracterActions.deleteTempDoc,
  downloadCheckedDocs: certboxActions.downloadCheckedDocs,

  success: alertActions.success,
  confirm: alertActions.confirm,
  error: alertActions.error,

  getDownLoad: certboxActions.getDownLoad,
  showModalBagic: modalActions.showModalBagic,
  clearModal: modalActions.clearModal,
}

export default connect(mapStateToProps, actionCreators)(CertboxList)
